var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSec1ListToneOfVoice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.996,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5542 3.24709C15.0722 3.13412 15.4487 3.30925 15.6838 3.77248C15.7188 11.2679 15.7188 18.7633 15.6838 26.2588C15.5362 26.6259 15.2648 26.801 14.8694 26.7842C14.4739 26.801 14.2025 26.6259 14.0551 26.2588C14.02 18.7633 14.02 11.2679 14.0551 3.77248C14.1613 3.53501 14.3277 3.35988 14.5542 3.24709Z",
    fill: "#6A097D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.995,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.11476 5.59565C7.6925 5.46965 8.11243 5.66496 8.37453 6.18158C8.41361 12.3534 8.41361 18.5254 8.37453 24.6972C8.21005 25.1066 7.90736 25.3019 7.46632 25.2832C7.02529 25.3019 6.7226 25.1066 6.55812 24.6972C6.51904 18.5254 6.51904 12.3534 6.55812 6.18158C6.6766 5.91674 6.86216 5.72143 7.11476 5.59565Z",
    fill: "#6A097D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.995,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1147 5.59565C22.6926 5.46965 23.1125 5.66496 23.3745 6.18158C23.4136 12.3534 23.4136 18.5254 23.3745 24.6972C23.2101 25.1066 22.9074 25.3019 22.4664 25.2832C22.0253 25.3019 21.7226 25.1066 21.5581 24.6972C21.519 18.5254 21.519 12.3534 21.5581 6.18158C21.6766 5.91674 21.8622 5.72143 22.1147 5.59565Z",
    fill: "#6A097D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8647 8.40814C11.4425 8.28216 11.8624 8.47745 12.1245 8.99408C12.1636 13.2909 12.1636 17.5879 12.1245 21.8847C11.96 22.2941 11.6574 22.4894 11.2164 22.4707C10.7753 22.4894 10.4726 22.2941 10.3081 21.8847C10.269 17.5879 10.269 13.2909 10.3081 8.99408C10.4266 8.72923 10.6122 8.53394 10.8647 8.40814Z",
    fill: "#6A097D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3647 8.40814C18.9426 8.28216 19.3625 8.47745 19.6245 8.99408C19.6636 13.2909 19.6636 17.5879 19.6245 21.8847C19.4601 22.2941 19.1574 22.4894 18.7164 22.4707C18.2753 22.4894 17.9726 22.2941 17.8081 21.8847C17.769 17.5879 17.769 13.2909 17.8081 8.99408C17.9266 8.72923 18.1122 8.53394 18.3647 8.40814Z",
    fill: "#6A097D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.988,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.36475 11.2207C3.94249 11.0947 4.3624 11.29 4.62452 11.8065C4.66358 14.2284 4.66358 16.6503 4.62452 19.0722C4.46005 19.4816 4.15732 19.6769 3.71631 19.6582C3.27531 19.6769 2.97257 19.4816 2.80811 19.0722C2.76904 16.6503 2.76904 14.2284 2.80811 11.8065C2.9266 11.5418 3.11215 11.3464 3.36475 11.2207Z",
    fill: "#6A097D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.988,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8647 11.2207C26.4426 11.0947 26.8625 11.29 27.1245 11.8065C27.1636 14.2284 27.1636 16.6503 27.1245 19.0722C26.9601 19.4816 26.6574 19.6769 26.2164 19.6582C25.7753 19.6769 25.4726 19.4816 25.3081 19.0722C25.269 16.6503 25.269 14.2284 25.3081 11.8065C25.4266 11.5418 25.6122 11.3464 25.8647 11.2207Z",
    fill: "#6A097D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec1ListToneOfVoice);
export default __webpack_public_path__ + "static/media/Sec1-List-Tone-Of-Voice.cde59a7814889cfa343f0eeba1244066.svg";
export { ForwardRef as ReactComponent };